import * as types from '../mutations-types'

// initial state
const state = {
  attendanceStroeData: {},
  roleData: {}
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.SET_ATTENDANCE_STROE_DATA](state, data) {
    state.attendanceStroeData = data
  },
  [types.SET_ATTENDANCE_ROLE_DATA](state, data) {
    state.roleData = data
  }
}
// getters
const getters = {}

export default {
  state,
  getters,
  actions,
  mutations
}
